import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {ApiService, CustomHttpParams} from 'src/app/services/api.service';
import {extractErrorMessage} from "../../../common/common";
import {LoaderComponent} from "../../common/loader/loader.component";
import {MetadataReportViewModel} from "../../../model/metadataReports.model";

@Component({
  selector: 'app-generate-metadata-report-index',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, LoaderComponent],
  templateUrl: './generate-metadata-report.component.html',
  styleUrl: './generate-metadata-report.component.scss'
})
export class GenerateMetadataReportComponent implements OnInit {
  protected isLoading: boolean = false;
  protected reports: MetadataReportViewModel[] = [];
  protected result: string | null = "No results yet.";
  protected error: string | null = null;
  protected id: string = '';

  constructor(private metadataReportService: ApiService) {}

  ngOnInit(): void {
    this.isLoading = true;
    const queryParams: CustomHttpParams = {};
    this.metadataReportService.getMetadataReports(queryParams).subscribe({
      next: (response: MetadataReportViewModel[]) => {
        this.reports = response;
        this.isLoading = false;
      },
      error: (err: any) => {
        console.error(err);
        this.error = extractErrorMessage(err,"Failed to load metadata reports.");
        this.isLoading = false;
      }
    });
  }

  setId(event: any){
    this.id = event.value;
  }

  performAction() {
    if (!this.id) {
      this.error = "Please select a metadata report.";
      return;
    }

    this.error = null;
    this.isLoading = true;
    this.metadataReportService.metadataReportMessage({id: this.id}).subscribe({
      next: (response: any) => {
        // Format XML for display
        try {
          this.result = new DOMParser()
            .parseFromString(response, "text/xml")
            .documentElement.outerHTML
            .replace(/></g, ">\n<")
            .replace(/><\/(\w+)/g, ">\n</\$1")
            .replace(/<(\w+)>/g, "<\$1>\n")
            .replace(/\n{2,}/g, "\n");
        } catch (e) {
          this.result = response;
        }
        this.isLoading = false;
      },
      error: (err: any) => {
        console.error(err);
        this.error = extractErrorMessage(err, "An error occurred while generating the metadata report message.");
        this.isLoading = false;
      }
    });
  }
}
